export default __webpack_public_path__ + "static/media/dartboard.5e3e28d2.png";